import React from "react";

import { GlobalServerResponseErrorHandler } from "@/Common/Api/GlobalServerResponseErrorHandler";
import { Dispatcher } from "@/Common/Stores/Actions/ActionDispatcher";

// Myle App
window.ClickDispatcher = new Dispatcher<any>();
window.LocalEventDispatcher = new Dispatcher<any>();
window.MainComponentStateDispatcher = new Dispatcher<any>();
window.MiscDispatcher = new Dispatcher<any>();
window.RAMQEventDispatcher = new Dispatcher<any>();
window.ServerResponseDispatcher = new Dispatcher<any>();
window.baseURI = window.location.host;
window.currentLang = window.currentLang ?? "";
window.globalServerResponseHandler = new GlobalServerResponseErrorHandler();
window.rootPath = "";

// Stores
window.administrationStore = null;
window.apiSettings = null;
window.billingStore = null;
window.cacheStore = null;
window.calendarStore = null;
window.communicationsStore = null;
window.documentsStore = null;
window.globalSendCommunicationStore = null;
window.labsStore = null;
window.listsStore = null;
window.navStore = null;
window.overlayStore = null;
window.paListStore = null;
window.patientStore = null;
window.portfolioStore = null;
window.ramqStore = null;
window.reportingStore = null;
window.schedulingStore = null;
window.sessionStore = null;
window.settingsStore = null;
window.sidebarStore = null;
window.prescriptionRenewalsStore = null;
window.pharmacyOrdersStore = null;
window.aiScribeStore = null;

// Hand notes
window.HandNoteModule = {
    localNoteDispatcher: null,
    noteStore: null,
    serverNoteDispatcher: null
};

// React
window.React = React;
